import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import fr from 'vuetify/es5/locale/fr';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#76777a",
        secondary: "#757575",
        accent: "#d8e079",
        success: "#4caf50",
        warning: "#ffa407",
      },
      dark: {
        primary: "#3a3838",
        secondary: "#757575",
      },
    },
  },
  lang: {
    locales: { fr },
    current: 'fr',
  },
});
